import PartsManager from "../../pages/report/parts";
import { PartsDetailsPage } from "../../pages/report/parts/PartsDetailsPage";

export const routePartsManager = "/parts-manager";
export const partsPermission = "ui.navbar.parts";

export const reportRoutes = [
	{
		path: routePartsManager,
		element: <PartsManager />,
		permission: partsPermission,
	},
	{
		path: `${routePartsManager}/:partId`,
		element: <PartsDetailsPage />,
		permission: partsPermission,
	},
];
